import { FAQDrawer } from '@app/analytics/src/components/Reports/FAQDrawer'
import { GetServerSideProps } from 'next'
import { PageContainer } from '../../../components/layout'
import { ReportDashboardContainer } from '@app/analytics/src/containers/reportDashboard'
import { ReportsFAQDataType } from '@dtx-company/true-common/src/types/prismic'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { prismicClient } from '@app/prismic/src/utils'

import { FC } from 'react'
import { logger } from '@dtx-company/logger'
import { setWebPageCacheControl } from '../../../utils/cache'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useRedirectOnAuthChanges } from '@dtx-company/inter-app/src/hooks/auth/useRedirectOnAuthChanges'

export const getServerSideProps: GetServerSideProps = async ctx => {
  const reportsFAQData = await prismicClient
    .getSingle('reportsfaq', {})
    .then(resp => {
      const { drawer_header, accordion_sections } = resp.data
      return { drawer_header, accordion_sections }
    })
    .catch(err =>
      logger.logError(err, {
        team: 'flowlytics'
      })
    )

  setWebPageCacheControl(ctx.res, 300)

  return {
    props: { reportsFAQData }
  }
}

const Dashboard: FC<{
  reportsFAQData: ReportsFAQDataType
}> = ({ reportsFAQData }) => {
  const { isAuthChecked } = useAuthState()

  useRedirectOnAuthChanges(true)

  return (
    <PageContainer hideContentIfLoggedOut page={Routes.REPORTS} fillWidth>
      {isAuthChecked && <ReportDashboardContainer />}
      <FAQDrawer drawerContent={reportsFAQData} />
    </PageContainer>
  )
}

export default Dashboard
